import React from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';

import { DraggableItemData } from './DraggableWidgetCard';
import { useDraggingContext } from '../../hooks';

const DragDropContextComponent = DragDropContext as any;
const DroppableComponent = Droppable as any;

interface DraggableWrapperProps {
  items: DraggableItemData<any>[];
  onItemsReordered: (reorderedItems: DraggableItemData<any>[]) => void;
  children: React.ReactNode;
}

export const DraggableWrapper: React.FC<DraggableWrapperProps> = ({
  items,
  onItemsReordered,
  children,
}) => {
  // Get the dragging context handlers
  const { handleDragStart, handleDragEnd: contextHandleDragEnd } = useDraggingContext();

  // Handle the drag end event and reorder items
  const handleDragEnd = (result: DropResult) => {
    // If dropped outside a droppable area, do nothing
    if (!result.destination) return;

    // Create a copy of the items array
    const reorderedItems = [...items];
    // Remove the dragged item from its original position
    const [removed] = reorderedItems.splice(result.source.index, 1);
    // Insert it at the new position
    reorderedItems.splice(result.destination.index, 0, removed);

    // Call the callback with the reordered items
    onItemsReordered(reorderedItems);
  };

  return (
    <DragDropContextComponent
      onDragStart={handleDragStart}
      onDragEnd={(result) => {
        // Call both handlers
        contextHandleDragEnd(result);
        handleDragEnd(result);
      }}>
      <DroppableComponent droppableId="droppable-widgets" direction="horizontal">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
            {children}
            {provided.placeholder}
          </div>
        )}
      </DroppableComponent>
    </DragDropContextComponent>
  );
};
